<template>
    <TheHeader bgClass="header-bg-color" fontClass="fontColor2"/>

    <ThePageSubTitle titleMsg="Contact Us" msg="Reach Us By"/>
    <br/>
    <br/>
    <div class="contact-main-wrapper">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.3339956663017!2d101.73239928312232!3d3.0045013891626993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cdcaee3d34c2d1%3A0xaba5d1f89a462718!2sMalaysia%20Mobile%20Crane%20Owners%20Association%20(MMCOA)!5e0!3m2!1sen!2smy!4v1751984127696!5m2!1sen!2smy" 
            width="100%" 
            height="450" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
        </iframe>
    </div>
    <br/>

    <div class="main-contact-wrapper montserrat-500">
      <div class="contact-wrap">
        <span class="poppins-semi fontColor2" style="font-size: 15px;">Find us at the office:</span>
        <br/>
        20-2, Jalan Balakong Jaya 8, <br/>
        Taman Balakong Jaya, <br/>
        43200 Balakong, <br/>
        Selangor Darul Ehsan, Malaysia.
      </div>
      <div class="contact-wrap">
        <span class="poppins-semi fontColor2" style="font-size: 15px;">Phone:</span>
        <br/>
        +603-8959 0390 
        <br/>
        +6018-3981987 (Isaac)
        <br/>
        +6018-2621987 (May)
      </div>
      <div class="contact-wrap">
        <span class="poppins-semi fontColor2" style="font-size: 15px;">Fax:</span>
        <br/>
        +603-8959 0390
      </div>
      <div class="contact-wrap">
        <span class="poppins-semi fontColor2" style="font-size: 15px;">Application for Membership PDF:</span>
        <br/>
        <a href="/download.pdf" target="_blank" rel="noopener noreferrer">Click HERE</a>
      </div>
    </div>
    <br/>

    <div class="form-wrapper">
      <div class="contact-form">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe6-0usaDCkzg-g2bgt_LtpU6hQ8WKvRklFnuJgRfEHtA6SHg/viewform?embedded=true" width="100%" height="821" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </div>
      <div class="contact-form">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScMCnOq-BXwVhqAyArWYjkS2CcDVJCq3B930_E4FjK9NvHGDw/viewform?embedded=true" width="100%" height="821" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </div>
    </div>


    <br/>
    <TheSponsor bgClass="header-bg-color"/>

    <!-- Copyright -->
    <TheCopyRight/>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheSponsor from '@/components/TheSponsor.vue'
import TheCopyRight from '@/components/TheCopyRight.vue'
import ThePageSubTitle from '@/components/ThePageSubTitle.vue'

export default {
  name: 'About Us',
  components: {
    TheHeader,
    TheSponsor,
    TheCopyRight,
    ThePageSubTitle
  }
}

</script>

<style scoped>
.contact-main-wrapper {
    margin: 0 auto;
    width: 80%;
}
.main-contact-wrapper {
  text-align: center;
}
.contact-wrap {
  color: #666666;
  width: 100%;
  margin-bottom: 10px;
}
.form-wrapper {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .main-contact-wrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
    margin: 0 auto;
  }
  .contact-wrap {
    width: 50%;
    font-size: 13px;
  }
}


@media screen and (min-width: 1024px) {
  .contact-wrap {
    width: 25%;
  }
}

@media screen and (min-width: 1280px) {
  .form-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .contact-form {
    width: 40%;
    margin: 0 auto;
  }
}
</style>